import styled from 'styled-components/macro';
import React from 'react';

import { Flex } from 'modsy-ui-kit';

export default ({ navItemsLhs, navItemsRhs }) => (
  <NavbarItemsContainer>
    <NavItems>
      {navItemsLhs}
    </NavItems>

    <NavItems>
      {navItemsRhs}
    </NavItems>
  </NavbarItemsContainer>
);

/**
 * Navigation items full navbar.
 * We have a LHS group that comes right after logo.
 * We have a RHS group fixed to end of navbar.
 */
const NavbarItemsContainer = styled(Flex)`
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;

export const NavItems = styled(Flex)`
  align-items: center;
  flex-direction: row;
`;
